import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";

export const actionCreators = {

    DeleteUserGroupMembership: (userGroupMembership, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroupMemberships/" + userGroupMembership.userGroupId + "/" + userGroupMembership.userId, {
            method: "DELETE"
        }).then((data) => {
            onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    CreateUserGroupMembership: (userGroupMembership, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroupMemberships", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(userGroupMembership),
            method: "POST"
        }).then((data) => {
            onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    DeleteInvitationUserGroupMembership: (userGroupMembership, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/InvitationUserGroupMemberships/" + userGroupMembership.invitationId + "/" + userGroupMembership.userGroupId, {
            method: "DELETE"
        }).then((data) => {
            onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    CreateInvitationUserGroupMembership: (userGroupMembership, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/InvitationUserGroupMemberships", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(userGroupMembership),
            method: "POST"
        }).then((data) => {
            onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    }

};
